// extracted by mini-css-extract-plugin
export default {"modalHeader":"CategoryModal_modalHeader__tnOvx","modalBody":"CategoryModal_modalBody__U-bO0","richInputWrapper":"CategoryModal_richInputWrapper__kWzQI"};